export const tableFieldDeliveryAddress = [
  { text: 'langkey.extended_delivery_adress_name', align: 'center', value: 'name' },
  { text: 'langkey.extended_delivery_adress_street', align: 'center', value: 'street' },
  { text: 'langkey.extended_delivery_adress_number', align: 'center', value: 'streetNumber' },
  { text: 'langkey.extended_delivery_adress_code', align: 'center', value: 'zip' },
  { text: 'langkey.extended_delivery_adress_city', align: 'center', value: 'city' },
  { text: 'langkey.extended_delivery_adress_country', align: 'center', value: 'countryCode' },
  { text: 'langkey.extended_delivery_adress_standard', align: 'center', value: 'default' },
  { text: 'langkey.adding_new_delivery_address', align: 'right', value: 'function', width: '100' },
];